export default __webpack_public_path__ + "static/smellsLikeStrawberry-7793816d3c8a5cd888c44460c45c825e.png";